import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

export const TECHNICAL_CONTROLS_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'tech-identity-access',
    name_en: 'Identity & Access',
    name_es: 'Identidad y Acceso',
    name_ru: 'Идентичность и доступ',
    questions: [
      { id: 'tech_ia1', blockId: 'tech-identity-access', text_en: 'MFA enabled for all privileged accounts?', text_es: '¿MFA habilitado para cuentas privilegiadas?', text_ru: 'Включена ли MFA для привилегированных учётных записей?' },
      { id: 'tech_ia2', blockId: 'tech-identity-access', text_en: 'SSO used?', text_es: '¿SSO utilizado?', text_ru: 'Используется ли SSO?' },
      { id: 'tech_ia3', blockId: 'tech-identity-access', text_en: 'Access reviews performed regularly?', text_es: '¿Revisión de accesos realizada regularmente?', text_ru: 'Регулярно проводятся ли проверки доступа?' },
    ],
  },
  {
    id: 'tech-network',
    name_en: 'Network & Segmentation',
    name_es: 'Red y Segmentación',
    name_ru: 'Сеть и сегментация',
    questions: [
      { id: 'tech_n1', blockId: 'tech-network', text_en: 'Network is segmented?', text_es: '¿Red segmentada?', text_ru: 'Сегментирована ли сеть?' },
      { id: 'tech_n2', blockId: 'tech-network', text_en: 'Firewalls configured and monitored?', text_es: '¿Firewalls configurados y monitoreados?', text_ru: 'Настроены и контролируются ли файрволы?' },
    ],
  },
  {
    id: 'tech-endpoint',
    name_en: 'Endpoint Security',
    name_es: 'Seguridad de Endpoints',
    name_ru: 'Безопасность конечных точек',
    questions: [
      { id: 'tech_e1', blockId: 'tech-endpoint', text_en: 'Endpoint protection (EDR/AV) deployed?', text_es: '¿Protección de endpoints (EDR/AV) desplegada?', text_ru: 'Развёрнута ли защита конечных точек (EDR/AV)?' },
      { id: 'tech_e2', blockId: 'tech-endpoint', text_en: 'Patch management SLA met?', text_es: '¿SLA de gestión de parches cumplido?', text_ru: 'Соблюдается ли SLA по управлению патчами?' },
    ],
  },
  {
    id: 'tech-logging',
    name_en: 'Logging & Monitoring',
    name_es: 'Registro y Monitoreo',
    name_ru: 'Логирование и мониторинг',
    questions: [
      { id: 'tech_l1', blockId: 'tech-logging', text_en: 'Logs centralized (SIEM)?', text_es: '¿Logs centralizados (SIEM)?', text_ru: 'Централизованы ли логи (SIEM)?' },
      { id: 'tech_l2', blockId: 'tech-logging', text_en: 'Alerts tuned and reviewed?', text_es: '¿Alertas ajustadas y revisadas?', text_ru: 'Настроены и проверяются ли оповещения?' },
    ],
  },
  {
    id: 'tech-ir',
    name_en: 'Incident Response',
    name_es: 'Respuesta a Incidentes',
    name_ru: 'Реагирование на инциденты',
    questions: [
      { id: 'tech_ir1', blockId: 'tech-ir', text_en: 'Documented IR plan?', text_es: '¿Plan IR documentado?', text_ru: 'Документирован ли план реагирования на инциденты?' },
      { id: 'tech_ir2', blockId: 'tech-ir', text_en: 'IR exercises held annually?', text_es: '¿Ejercicios IR realizados anualmente?', text_ru: 'Проводятся ли учения IR ежегодно?' },
    ],
  },
];

export const TECHNICAL_CONTROLS_QUESTIONNAIRES = {
  SELF_ASSESSMENT: TECHNICAL_CONTROLS_SELF_ASSESSMENT_BLOCKS,
};
